import { render, staticRenderFns } from "./messageTipModal.vue?vue&type=template&id=78ff9b6e&scoped=true"
import script from "./messageTipModal.vue?vue&type=script&lang=js"
export * from "./messageTipModal.vue?vue&type=script&lang=js"
import style0 from "./messageTipModal.vue?vue&type=style&index=0&id=78ff9b6e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "78ff9b6e",
  null
  
)

export default component.exports